import { clockSvg, locationOutlinedSvg, CalenderSvg } from "helper/helper";
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import UpComingTimer from "components/upComingTripDetail/UpComingTimer";
import useApiHook from 'hooks/useApiHook';
import { dateComing } from "helper/functionality";
import { AiOutlineClockCircle } from "react-icons/ai";
import moment from "moment";
import { instanceNREL } from "utls/instances";
import { getTripDetailDirections } from "utls/apiCalls/googleApi";
import { toast } from "react-toastify";
import TripEVMarker from "components/home/TripEVMarker";
import { DirectionsRenderer, GoogleMap } from "@react-google-maps/api";

const TripDetail = () => {
  const { tripId } = useParams();
  const { handleApiCall } = useApiHook();
  const [tripDetail, setTripDetail] = useState(null);
  const [directions, setDirections] = useState(null);
  const [remainingTime, setRemainingTime] = useState(null);
  const [allEVs, setAllEVs] = useState(null);
  const [isLoading, setIsLoading] = useState(true);
  const [_, setDirectionUrl] = useState("");

  useEffect(() => {
    getTripDetail();
  }, [tripId]);

  const getDirections = async ({
    origin,
    destination,
    stops,
    network,
    chargersType,
    connector,
  }) => {
    setIsLoading(false);
    const result = await getTripDetailDirections({
      origin,
      destination,
      stops: stops?.map((stop) => stop?.name),
    });
    if (result.isSuccess) {
      setDirections(result?.data);
      let lineString = result?.data.routes[0].overview_path
        ?.map((point) => {
          return `${point.lng()} ${point.lat()}`;
        })
        ?.join(", ");
      getAllEV({
        directions: result?.data,
        network,
        chargersType,
        connector,
        lineString,
        retryTime: 0,
      });
      let url = "https://www.google.com/maps/dir/";
      result?.data?.routes[0]?.legs?.map((direction, ind) => {
        if (ind === 0) {
          url += `${direction?.start_location?.lat()} ${direction?.start_location?.lng()}/${direction?.end_location?.lat()} ${direction?.end_location?.lng()}`;
        } else if (ind === result?.data?.routes[0]?.legs?.length - 1) {
          url += `/${direction?.end_location?.lat()} ${direction?.end_location?.lng()}/&dirflg=d`;
        } else {
          url += `/${direction?.end_location?.lat()} ${direction?.end_location?.lng()}`;
        }
      });
      setDirectionUrl(url);
    }
  };

  const getAllEV = async ({
    network,
    chargersType,
    connector,
    lineString,
    retryTime = 0,
  }) => {
    if (retryTime > 1) return;
    try {
      let url = `alt-fuel-stations/v1/nearby-route.json?route=LINESTRING(${lineString})&ev_network=${network}&ev_connector_type=${connector}&status=${
        chargersType === "availableChargers" ? "E" : "all"
      }&distance=1`;
      const result = await instanceNREL.get(url);
      if (result.status === 200) setAllEVs(result?.data);
    } catch (error) {
      setIsLoading(false);
      if (error?.code === "ERR_NETWORK") {
        let lineString = directions.routes[0].overview_path
          ?.map((point, index) => {
            if (index === directions.routes[0].overview_path?.length - 1)
              return `${point.lng()} ${point.lat()}`;
            else if (index % 2 === 0) return `${point.lng()} ${point.lat()}, `;
          })
          .join("");
        return getAllEV({
          network: tripDetail?.network,
          chargersType: tripDetail?.chargersType,
          connector: tripDetail?.connector,
          lineString,
          retryTime: retryTime + 1,
        });
      }
      toast.error("No pins found against this route.");
    }
  };

  const getTripDetail = async () => {
    setIsLoading(true);
    const result = await handleApiCall({
      method: 'get',
      url: `/admin/trip/detail/${tripId}`,
    });

    if (result.status === 200) {
      const trip = result?.data?.trip
      setTripDetail(trip);
      getDirections(trip);
      setRemainingTime(
        dateComing(
          trip?.startDate && trip?.startTime
            ? trip?.startTime
            : trip?.startDate &&
              new Date(trip?.startDate).getDate() ===
                new Date().getDate() &&
              new Date(trip?.startDate).getMonth() ===
                new Date().getMonth() &&
              new Date(trip?.startDate).getFullYear() ===
                new Date().getFullYear()
            ? new Date(new Date(new Date().setHours(23)).setMinutes(59))
            : trip?.startDate
        )
      );
    }
  };

  if (isLoading) {
    return (
      <div className="flex items-center justify-center h-screen">
        <p>Loading...</p>
      </div>
    );
  }

  return (
    <div className='ez__Home w-full relative z-1 p-5 pb-10 flex flex-col gap-5'>
      <div className='flex flex-row justify-between items-center '>
        <h1 className='text-base text-ezBlack font-medium'>Trip to {tripDetail?.destination?.text || "Trip Details"}</h1>
      </div>

      {/* <div className='bg-white p-5 border border-ezGreen rounded grid grid-cols-2 md:grid-cols-4 gap-3'>
        <div>
          <p className='text-xs font-light mb-1'>Trip ID</p>
          <h5 className='text-sm font-medium'>{tripDetail?._id || "N/A"}</h5>
        </div>
        <div>
          <p className='text-xs font-light mb-1'>User Email</p>
          <h5 className='text-sm font-medium'>{tripDetail?.user?.email || "N/A"}</h5>
        </div>
        <div>
          <p className='text-xs font-light mb-1'>User Name</p>
          <h5 className='text-sm font-medium'>{tripDetail?.user?.name || "N/A"}</h5>
        </div>
        <div>
          <p className='text-xs font-light mb-1'>Org Name</p>
          <h5 className='text-sm font-medium'>{tripDetail?.organization?.name || "N/A"}</h5>
        </div>
      </div> */}
      
      {/* Rest of your component */}
      <div className='grid md:grid-cols-2 gap-4'>
        <div className='flex flex-col gap-3'>
          <div className='bg-white p-5 border border-ezRed rounded'>
            <p className='text-sm font-medium text-ezBlack'>Trip Details:</p>
            <div className='flex items-center justify-center mt-3 gap-2 text-ezBlack'>
              {remainingTime?.includes("day") ||
              remainingTime?.includes("month") ||
              remainingTime?.includes("year") ? (
                <p className="flex items-center justify-center w-full text-ezGray text-base">
                  <AiOutlineClockCircle className="mr-2" />{" "}
                  {tripDetail?.startDate ? remainingTime : "Not Scheduled"}{" "}
                  {tripDetail?.startDate && "To Go"}
                </p>
              ) : (
                <UpComingTimer
                  startTime={
                    tripDetail?.startDate && tripDetail?.startTime
                      ? tripDetail?.startTime
                      : tripDetail?.startDate
                      ? new Date(
                          new Date(new Date().setHours(23)).setMinutes(59)
                        )
                      : null
                  }
                />
              )}
            </div>
          </div>
          <div className='bg-white p-5 border border-ezGreen rounded flex flex-col gap-3'>
            <p className='text-sm font-medium text-ezBlack'>Trip Details:</p>
            <div className=' flex flex-col gap-3'>
              <div className='flex items-center gap-2 text-ezBlack'>
                <span>{locationOutlinedSvg}</span>
                <p className='text-xs font-medium text-ezLightGray'>{tripDetail?.destination?.text || "Trip destination"}</p>
              </div>
              <div className='flex items-center justify-between'>
                <div className='flex items-center gap-2 text-ezBlack'>
                  <span>{CalenderSvg}</span>
                  <p className='text-xs font-medium text-ezLightGray'>
                    {tripDetail?.startDate ? moment(new Date(tripDetail?.startDate)).format("MM/DD/YYYY") : "N/A"}
                  </p>
                </div>
                <div className='flex items-center gap-2 text-ezBlack mr-20'>
                  <span>{clockSvg}</span>
                  <p className='text-xs font-medium text-ezLightGray'>{tripDetail?.time || "N/A"}</p>
                </div>
              </div>
            </div>
            <div className='border-y flex gap-3 items-center justify-between py-6 my-3'>
              <div className='text-ezBlack'>
                <p className='text-base font-bold capitalize mb-2'>{tripDetail?.vehicleId?.make?.make}</p>
                <p className='text-xs font-medium'>Model: {tripDetail?.vehicleId?.make?.models?.filter(model => model?._id === tripDetail?.vehicleId?.model)[0]?.model}</p>
                <p className='text-xs font-medium'>Range: {tripDetail?.vehicleId?.range}</p>
              </div>
              <div className='w-32'>
                <img src={
                      tripDetail?.vehicleId?.picture
                        ? tripDetail?.vehicleId?.picture
                        : "/assets/images/carImg2.png"
                    } alt='vehicle_img' />
              </div>
            </div>
            <div className='flex flex-col gap-2'>
              <p className='font-semibold'>
                Origin: <span className='font-normal'>{tripDetail?.origin?.text || "N/A"}</span>
              </p>
              <p className='font-semibold'>
                Destination: <span className='font-normal'>{tripDetail?.destination?.text || "N/A"}</span>
              </p>
              <p className='font-semibold'>
                Energy: <span className='font-normal'>{tripDetail?.energy || "84 kWh"}</span>
              </p>
              <p className='font-semibold'>
                Average Speed: <span className='font-normal'>{tripDetail?.averageSpeed || "65 mph"}</span>
              </p>
              <p className='font-semibold'>
                Total Miles: <span className='font-normal'>{tripDetail?.totalMiles || "1303 miles"}</span>
              </p>
            </div>
          </div>
        </div>
        <div className='border border-ezGreen rounded'>{directions && (
                <GoogleMap
                  mapContainerStyle={{ width: "100%", height: "100%" }}
                  options={{ minZoom: 4, maxZoom: 18 }}
                >
                  {directions && (
                    <DirectionsRenderer
                      directions={directions}
                      options={{
                        polylineOptions: {
                          strokeOpacity: 1,
                          strokeColor: "#228B22",
                          strokeWeight: 5,
                        },
                      }}
                    />
                  )}

                  {allEVs?.fuel_stations?.length > 0 &&
                    allEVs?.fuel_stations?.map((ev) => (
                      <TripEVMarker
                        key={`EVDetailPointsKey${
                          ev?.id
                        }--${new Date().getTime()}`}
                        ev={ev}
                      />
                    ))}
                </GoogleMap>
              )}</div>
      </div>
    </div>
  );
};

export default TripDetail;
